import { render, staticRenderFns } from "./RefundDetil.vue?vue&type=template&id=71454d9e&scoped=true"
import script from "./RefundDetil.vue?vue&type=script&lang=ts&setup=true"
export * from "./RefundDetil.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RefundDetil.vue?vue&type=style&index=0&id=71454d9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71454d9e",
  null
  
)

export default component.exports